import { Component } from '@angular/core';
import { BaseComponent } from '../shared/base-components/base.component';

@Component({
    selector: '[not-found]',
    templateUrl: './api-response-service-unavailable.html'
})

export class ApiResponseServiceUnavailableComponent extends BaseComponent {

    constructor(
    ) {
        super();

    }

    ngOnInit() {

    }
}
